// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3s-4R","upload":"Small_upload__2tJIo","imageWrap":"Small_imageWrap__2HiOA","removeBtn":"Small_removeBtn__2heo1"};